import { AxiosAuthInstance } from "config/axios";
import { PrivateAxiosInstance } from "config/axios";

const maping = {store_provider:'provider',laundray:'laundry',admin:'admin'}
const url = process.env.REACT_APP_APPLICATION_NAME;
console.log(url,'alsdfjhsladkj')

const getAppName = (appName) => {
  switch (appName) {
    case 'provider':
      return 'provider';
    case 'admin':
      return 'admin';
    default:
      return 'laundry';
  }
};
const route = getAppName(url);

export const API_POST__LOGIN = async (data) => {
  // const url = process.env.REACT_APP_APPLICATION_NAME === 'store_provider' ? "/auth/provider/login" : "/auth/admin/login"
  
  try {
    const response = await AxiosAuthInstance.post(`login`, data);
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};

export const API_POST_CONTACT_US_PUBLIC = async (data) => {
  // const url = process.env.REACT_APP_APPLICATION_NAME === 'store_provider' ? "/auth/provider/login" : "/auth/admin/login"
  
  try {
    const response = await AxiosAuthInstance.post(`contact-us-public`, data);
    return response.data; // You may want to return the response data to handle it in your components
  } catch (error) {
    throw error; // Rethrow the error for handling in your components
  }
};
export const API_POST__FORGET_PASSWORD = async (data) => {
    try {
      const response = await AxiosAuthInstance.post(`forgot-password`, data);
      return response.data; // You may want to return the response data to handle it in your components
    } catch (error) {
      throw error; // Rethrow the error for handling in your components
    }
  };
  
  export const API_POST__VERIFY_OTP = async (data) => {
    try {
      const response = await AxiosAuthInstance.post(`verify-otp`, data);
      return response.data; // You may want to return the response data to handle it in your components
    } catch (error) {
      throw error; // Rethrow the error for handling in your components
    }
  };
  export const API_POST__RESET_PASSWORD = async (data) => {
    try {
      const response = await AxiosAuthInstance.post(`reset-password`, data);
      return response.data; // You may want to return the response data to handle it in your components
    } catch (error) {
      throw error; // Rethrow the error for handling in your components
    }
  };
  